const route = [
    {
        path: '/activity/2024qm/index', //2024下期末检测
        component: function (resolve) {
            require(['VIEWS/activity/2024qm/index.vue'], resolve);
        }
    },
]
export default route;
